const option_lookup = 'Costo del cliché (Obbligatorio)';
async function checkIfProperty() {
    let lineItem_hasCharge = [];

    const cartItems = await fetch('/cart.js')
        .then(response => response.json())
        .then(cart => cart.items)

    cartItems.forEach((item) => {
        if (item.properties.hasOwnProperty(option_lookup) && item.properties[option_lookup] != '') {
            lineItem_hasCharge.push({
                key: item.key,
                quantity: item.quantity,
                properties: item.properties
            })
        }
    })
    console.log(lineItem_hasCharge.length)
    if (lineItem_hasCharge.length > 1) resolveFetches(lineItem_hasCharge);
}

async function resolveFetches(queue) {
    queue = queue.splice(1);
    console.log(queue);
    for (const item of queue) {
        console.log(item)
        item.properties[option_lookup] = '';
        console.log(item.properties);
        console.log(item.properties[option_lookup])
        const response = await fetch('/cart/change.js', {

            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "id": item.key,
                "quantity": item.quantity,
                "properties": item.properties
            })
        })
    }
  window.location.reload();
}
checkIfProperty();



